
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { fantomTestnet } from 'viem/chains';


export const config = getDefaultConfig({
  appName: 'Agrifi',
  projectId: 'addab88384c055ccb46cdd3442576e06',
  chains: [fantomTestnet],
//   ssr: true, // If your dApp uses server side rendering (SSR)
} as const);